export default __webpack_public_path__ + "static/media/thum2.f970596b.jpg";